import styled from 'styled-components';

export const TestimonialsSection = styled.section`
  padding-bottom: 50px;

  .clients {
    margin-right: calc((1200px - 100vw) / 2);

    @media only screen and (max-width: 1200px) {
      margin-right: 0;
    }

    @media only screen and (max-width: 1024px) {
      padding-left: 0;
      padding-bottom: 50px;
    }
  }

  .client {
    min-height: 622px;
    background-color: ${({ theme: { colors } }) => colors.pink};
    padding: 45px 40px 45px;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    flex-direction: column;
    margin: 45px 0 0;
    background-position: center;
    background-size: cover;

    @media only screen and (max-width: 1024px) {
      padding: 30px 10px 45px;
    }

    @media only screen and (max-width: 767px) {
      min-height: auto;
    }

    h3 {
      font-size: 20px;
      letter-spacing: -0.21px;
      line-height: 1.34;
      font-weight: 400;

      @media only screen and (max-width: 1024px) {
        font-size: 22px;
        line-height: 29px;
      }
    }

    p {
      font-size: 19px;
      letter-spacing: 0.16px;
      line-height: 1.32;
      margin-top: 10px;
    }
  }
`;
